<bt-loader [loaderId]="loaderId">
  @if(dashboardSchema && products.data){
    <ng-container>
      <div class="card relative custom-margin">
        <h4 class="margin-bottom">Expenses</h4>
        @if(expensesChart){
          <div class="chart custom-margin-expensive">
            <canvas baseChart [data]="expensesChart.data" [options]="expensesChart.options" [type]="expensesChart.type">
            </canvas>
          </div>
        }
  
        <div class="bottom-cards padding">
          <div class="flex">
            <div class="flex-1 margin-right">
              <div class="card">
                <h4 class="margin-bottom">Database Status</h4>
                @if(databaseStatusChart){
                  <div class="pie">
                    <canvas baseChart [data]="databaseStatusChart.data" [options]="databaseStatusChart.options"
                      [type]="databaseStatusChart.type">
                    </canvas>
                  </div>
                }
              </div>
            </div>
            <div class="flex-1 margin-right">
              <div class="card">
                <h4 class="margin-bottom">No img items</h4>
                @if(noImgChart){
                  <div class="pie">
                    <canvas baseChart [data]="noImgChart.data" [options]="noImgChart.options" [type]="noImgChart.type">
                    </canvas>
                  </div>
                }
              </div>
            </div>
            <div class="flex-1">
              <div class="card">
                <h4 class="margin-bottom">Active photographers</h4>
                <div class="huge align-center"><b>{{dashboardSchema.activePhotographers.active}} of
                    {{dashboardSchema.activePhotographers.total}}</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- <h4 class="margin-bottom">Actions Shortcuts</h4>
      <div class="flex inline">
        <div class="flex-1 margin-right">
          <button><i class="fa fa-plus"></i> Create new item</button>
        </div>
        <div class="flex-1 margin-right">
          <button><i class="fa fa-plus"></i> Create new template</button>
        </div>
        <div class="flex-1 margin-right">
          <button><i class="fa fa-plus"></i> Create new custom order</button>
        </div>
        <div class="flex-1">
          <button><i class="fa fa-gear"></i> Manage protographer profile</button>
        </div>
      </div> -->
  
      <bt-loader [loaderId]="products.loaderId">
        <div class="flex margin-top">
          <div class="flex-2 margin-right">
            <h4 class="margin-bottom">Active Products</h4>
            <div class="card">
              @if(!!products.pageNumber || products.data?.length){
                <ng-container>
                  <table>
                    <tr>
                      @for(col of productsGridColumns; track col){
                      <th> {{col.title}}</th>
                      }
                    </tr>
                    @for(item of products.data; track item){
                    <tr>
                      @for(col of productsGridColumns; track col){
                      <td>
                        @if(col.type === gridColumnTypeEnum.default){
                          <ng-container>
                            {{item[col.field]}}
                          </ng-container>
                        }
                        @if(col.type === gridColumnTypeEnum.icon){
                          <ng-container>
                            <div class="pointer flex center justify-center" (click)="onInfo(item)">
                              <i class="fa fa-info"></i>
                            </div>
                          </ng-container>
                        }
                        @if(col.type === gridColumnTypeEnum.date){
                          <ng-container >
                            {{item[col.field] | date: 'd MMM y'}}
                          </ng-container>
                        }
                      </td>
                      }
                    </tr>
                    }
                  </table>
                  <bt-paginator [pageNumber]="products.pageNumber" [pageSize]="products.pageSize"
                    [totalNumber]="products.total" (clickPage)="getCompanyProducts($event)"></bt-paginator>
                </ng-container>
              }
              @if(products.data && !products.pageNumber && !products.data.length){
                <div class="no-data">
                  <i class="fa fa-frown-o"></i>
                  <div>There are no active products to view</div>
                </div>
              }
            </div>
          </div>
          <div class="flex-1">
            <h4 class="margin-bottom">
              Collaboration Requests
            </h4>
            <div class="card">
              @if(photographersOnRequest.data){
                <ng-container>
                  <table>
                    <tr>
                      @for(col of photographersColumns; track col){
                      <th [ngStyle]="{'width': col.width ? col.width + 'px' : null }">{{col.title}}</th>
                      }
                    </tr>
                    @for(item of photographersOnRequest.dataToView; track item){
                    <tr>
                      @for(col of photographersColumns; track col){
                      <td>
                        @if(col.type === gridColumnTypeEnum.icon){
                          <ng-container>
                            <bt-menu [show]="item.showMenu" (hidden)="item.showMenu = false" (showed)="item.showMenu = true">
                              <div class="menu-item" (click)="onItemAction(item, sidebarType.editInfo)">
                                <i class="fa fa-edit"></i>Edit info
                              </div>
                              <div class="menu-item" (click)="onItemAction(item, sidebarType.customOrder)">
                                <i class="fa fa-plus-circle"></i>Make custom order
                              </div>
                              <div class="menu-item warning" (click)="onItemAction(item, sidebarType.deleteAction)">
                                <i class="fa fa-trash"></i>Delete photographer
                              </div>
                            </bt-menu>
                          </ng-container>
                        }

                        @if(col.type === gridColumnTypeEnum.default){
                          <ng-container>
                            {{item[col.field]}}
                          </ng-container>
                        }
                      </td>
                    }
                    </tr>
                    }
                  </table>
                  <bt-paginator [pageNumber]="photographersOnRequest.page" [pageSize]="photographersOnRequest.size"
                    [totalNumber]="photographersOnRequest.data.length" (clickPage)="setPhotoToView($event)"></bt-paginator>
                </ng-container>
              }

              @if(photographersOnRequest.data && !photographersOnRequest.data.length){
                <div class="no-data">
                  <i class="fa fa-users"></i>
                  <div>There are no new collaboration requests</div>
                </div>
              }
            </div>
          </div>
        </div>
      </bt-loader>
    </ng-container>
  }
</bt-loader>

@if(tmpPhotog && currentSidebar === sidebarType.editInfo){
  <bt-sidebar sidebarTitle="Edit info"
    (exit)="tmpPhotog = null">
    <bt-sidebar-editinfo [photographer]="tmpPhotog" (saved)="savedInfo()"></bt-sidebar-editinfo>
  </bt-sidebar>
}

@if(tmpPhotog && currentSidebar === sidebarType.customOrder){
  <bt-sidebar sidebarTitle="Custom order"
    (exit)="tmpPhotog = null">
    <bt-sidebar-customorder [photographer]="tmpPhotog" (created)="createdCustomOrder()"></bt-sidebar-customorder>
  </bt-sidebar>
}

@if(tmpPhotog && currentSidebar === sidebarType.deleteAction){
  <bt-sidebar sidebarTitle="Dismiss photographer"
    (exit)="tmpPhotog = null">
    <div class="flex overflow vertical">
      <div class="flex-1 flex center">
        <div>
          Are you sure you want to <b>delete</b> {{tmpPhotog.fullName}}? Deleting photographer, you will remove him from
          the application
        </div>
      </div>
      <div class="flex-0">
        <button class="full-width warning" (click)="deletePhotographer()"><i class="fa fa-trash"></i>Delete
          photographer</button>
      </div>
    </div>
  </bt-sidebar>
}